(() => {
  if (window.keelSeparateGiftsInstalled) return;
  window.keelSeparateGiftsInstalled = true;
  const bundleIds = [55181956186449,55181956219217,55181956251985,55181956284753,55181956317521,55181956350289,55181956383057,55181956415825];
  const giftIds = [55186734416209,55186734743889,55186736972113];
  const oldKitId = 55181538099537;
  const shopRoot = window.Shopify?.routes?.root || '/';
  let busy = false;
  const request = async (path, body) => {
    const response = await fetch(shopRoot + path, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Your cart could not be updated. Please try again.');
    return result;
  };
  const giftCount = cart => cart.items.reduce((total,item) => total + (bundleIds.includes(item.variant_id) ? item.quantity : 0), 0);
  const update = async (updates, render) => {
    const drawer = document.querySelector('cart-drawer');
    const payload = {updates};
    if (drawer) { payload.sections = drawer.getSectionsToRender().map(section => section.id); payload.sections_url = window.location.pathname; }
    const cart = await request('cart/update.js',payload);
    if (render && window.location.pathname.replace(/\/$/,'').endsWith('/cart')) window.location.reload();
    else if (render && drawer) { drawer.classList.toggle('is-empty',cart.item_count === 0); drawer.renderContents(cart); }
    return cart;
  };
  const showError = error => {
    const target = document.querySelector('#CartDrawer-CartErrors, #cart-errors');
    if (target) target.textContent = error.message;
  };
  window.keelCartReady = (async () => {
    const cart = await request('cart.js');
    if (!cart.items.some(item => item.variant_id === oldKitId)) return;
    const count = giftCount(cart);
    if (!count) return;
    const updates = {};
    cart.items.filter(item => item.variant_id === oldKitId).forEach(item => {updates[item.key] = 0;});
    giftIds.forEach(id => {updates[id] = count;});
    await update(updates, true);
  })().catch(showError);
  const changeBundle = async (row, quantity) => {
    if (busy) return;
    busy = true;
    row.setAttribute('aria-busy','true');
    try {
      await window.keelCartReady;
      const cart = await request('cart.js');
      const index = Number(row.dataset.index || row.id.replace('CartItem-','')) - 1;
      const item = cart.items[index];
      if (!item || !bundleIds.includes(item.variant_id)) throw new Error('Please refresh the cart and try again.');
      const count = giftCount(cart) - item.quantity + quantity;
      const updates = {[item.key]:quantity};
      giftIds.forEach(id => {updates[id] = count;});
      await update(updates,true);
    } catch (error) {showError(error);}
    finally {busy=false;row.removeAttribute('aria-busy');}
  };
  document.addEventListener('change',event => {
    const input = event.target.closest('.quantity__input');
    const row = input?.closest('[data-keel-variant]');
    if (!row || !bundleIds.includes(Number(row.dataset.keelVariant))) return;
    event.stopImmediatePropagation();
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    changeBundle(row,quantity);
  },true);
  document.addEventListener('click',event => {
    const remove = event.target.closest('cart-remove-button');
    const row = remove?.closest('[data-keel-variant]');
    if (!row || !bundleIds.includes(Number(row.dataset.keelVariant))) return;
    event.preventDefault();event.stopImmediatePropagation();changeBundle(row,0);
  },true);
})();
